import DetectKeyboardFocus from './detect-keyboard-focus'

export default DetectKeyboardFocus
